import moment from 'moment';

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const handleDateFilter = (dates, type = 'birth_date') => {
  if (!dates?.reset) {
    const parsedFilters = {};
    if (dates.startDate) {
      parsedFilters[type + '__gte'] = formatDate(dates.startDate);
    }
    if (dates.endDate) {
      if (
        dates.startDate &&
        dates.endDate &&
        dates.startDate.getTime() === dates.endDate.getTime()
      ) {
        const nextDay = new Date(dates.endDate);
        nextDay.setDate(nextDay.getDate() + 1);
        parsedFilters[type + '__lte'] = formatDate(nextDay);
      } else {
        parsedFilters[type + '__lte'] = formatDate(dates.endDate);
      }
    }
    return parsedFilters;
  } else {
    return {};
  }
};

export const handleValidDate = (date) => {
  const date1 = moment(new Date(date)).format('DD MMM Y');
  return date1;
};
